import React, { useState, useMemo } from "react";
import debounce from "lodash.debounce";
import { TextField, InputAdornment } from "@mui/material";
import { Search } from "@mui/icons-material";
import styles from "./SearchBar.module.scss";

const SearchBar = ({ placeholderText, updateSearchText, delay = 1500 }) => {
  const [inputValue, setInputValue] = useState("");

  const debouncedChangesHandler = useMemo(
    () =>
      debounce((value) => {
        if (updateSearchText) {
          updateSearchText(value);
        }
      }, delay),
    [updateSearchText, delay]
  );

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
    debouncedChangesHandler(e.target.value);
  };

  return (
    <TextField
      fullWidth
      className={styles.searchContainer}
      placeholder={placeholderText}
      variant="outlined"
      size="small"
      value={inputValue}
      onChange={handleInputChange}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default SearchBar;
